export function pushEvent() {
  window.setTimeout(() => {
    const path = window.location.pathname + window.location.search + window.location.hash;
    // console.log("visiting " + path);
    // console.log("title " + document.title);
  
    if(window.goatcounter && window.goatcounter.count) {
      window.goatcounter.count({
        path: path,
        title: document.title
      })
    }
  }, 500);
}

